module.exports = __webpack_public_path__ + "img/close.72033c4b.svg";